import { render, staticRenderFns } from "./flfg.vue?vue&type=template&id=27874cca&scoped=true&"
import script from "./flfg.vue?vue&type=script&lang=js&"
export * from "./flfg.vue?vue&type=script&lang=js&"
import style0 from "./flfg.vue?vue&type=style&index=0&id=27874cca&scoped=true&lang=css&"
import style1 from "./flfg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27874cca",
  null
  
)

export default component.exports